var a=function(a){return this.__data__.has(a)};export{a as default};
//# sourceMappingURL=_setCacheHas.js.map
